import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const styles = {
  list: {
    width: 250
  },
  fullList: {
    width: "auto"
  },
  flex: {
    flex: 1
  }
};

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggleDrawer = (side, open) => () => {
      props.toggleDrawer();
    };
  }

  render() {
    const {classes, signOut} = this.props;

    return (
      <AppBar position="static">
        <Toolbar>
          {/* <IconButton
            className={classes.menuButton}
            color="inherit"
            aria-label="Menu"
            onClick={this.toggleDrawer("left", true)}>
            <MenuIcon/>
          </IconButton> */}
          <Typography variant="title" color="inherit" className={classes.flex}>
            {this.props.pagetitle || ""}
          </Typography>
          <Button
            size="small"
            color="inherit"
            className={classes.button}
            onClick={() => {
            signOut()
          }}>
            Sign Out
          </Button>
        </Toolbar>
      </AppBar>

    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  pagetitle: PropTypes.string,
  toggleDrawer: PropTypes.func,
  signOut: PropTypes.func
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js